import { render, staticRenderFns } from "./grid-section.vue?vue&type=template&id=2adbaf96"
import script from "./grid-section.vue?vue&type=script&lang=js"
export * from "./grid-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports